import {Form, GridColumn, GridRow, Input} from "semantic-ui-react";
import React, {FormEvent} from "react";
import {FormProps} from "semantic-ui-react/dist/commonjs/collections/Form/Form";

type APCoordinateSearchTypeProps = {
  handleChange: (e: FormEvent<HTMLFormElement>, {name, value}: FormProps) => void
  defaultRadius: number | undefined
  defaultLatitude: number | undefined
  defaultLongitude: number | undefined
}

const APCoordinateSearchPanel = ({
                                   handleChange,
                                   defaultLongitude,
                                   defaultLatitude,
                                   defaultRadius
                                 }: APCoordinateSearchTypeProps) => {
  return (
      <>
        <GridRow columns={2} className={'pointData'}>
          <GridColumn>
            <Form.Field control={Input} label="Latitude"
                        defaultValue={defaultLatitude}
                        type="number" name={'latitude'} onChange={handleChange}/>
          </GridColumn>
          <GridColumn>
            <Form.Field control={Input} label="Longitude"
                        defaultValue={defaultLongitude}
                        type="number" name={'longitude'} onChange={handleChange}/>
          </GridColumn>
        </GridRow>
        <GridRow>
          <GridColumn>
            <Form.Field control={Input} label="Radius (in metres)" defaultValue={defaultRadius} type="number"
                        name={'radius'} min="1" max="10000" onChange={handleChange}/>
          </GridColumn>
        </GridRow>

      </>
  )
}

export default APCoordinateSearchPanel